module.exports = __webpack_public_path__ + "img/881-2a7ff9.png";